export const ORDER_STATUS = {
  ORDER_CREATED    : 'ORDER_CREATED',
  SENT_TO_ATTENDEES: 'SENT_TO_ATTENDEES',
  ORDERS_PLACED    : 'ORDERS_PLACED',
  FINISHED         : 'FINISHED',
  BUILDING_BOXES   : 'BUILDING_BOXES',
  BOXES_BUILT      : 'BOXES_BUILT',
  OUT_FOR_DELIVERY : 'OUT_FOR_DELIVERY',
  CANCELLED        : 'CANCELLED',
  FULL_FILLED      : 'FULL_FILLED'
}